<template>
  <div class="order-evaluation">
    <div class="content-box">
      <div class="bread">
        <router-link class="bread-item" to="/">上上签</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" to="/orders">订单管理</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link
          class="bread-item"
          :to="{ name: 'orderEvaluation', params: { oid: $route.params.oid } }"
          ><span v-if="isdetail">评价详情</span
          ><span v-else>评价服务</span></router-link
        >
      </div>

      <div class="main-box">
        <div class="title">
          <div class="text">
            <span v-if="isdetail">评价详情</span><span v-else>评价服务</span>
          </div>
          <div class="desc">
            <span v-if="isdetail">感谢您的评价~</span
            ><span v-else>您的评价是我们前进的动力</span>
          </div>
        </div>

        <div class="order-info">
          <div
            :style="{ backgroundImage: 'url(' + nationalImg + ')' }"
            class="country-icon"
          ></div>
          <div class="text-box">{{ title }}</div>
        </div>
        <!-- 评价提交 -->
        <div class="submit-box" v-if="!isdetail">
          <div class="evaluation-box">
            <div class="evaluation-line-title">评价</div>
            <div
              class="evaluation"
              v-for="(item, eIndex) in evaluationList"
              :key="item.level"
              @click="handlerEvaluation(eIndex)"
              @mouseenter="item.show = true"
              @mouseleave="item.show = false"
            >
              <img
                :src="
                  item.checked || item.show ? item.checkedIcon : item.commonIcon
                "
                :class="['icon-box', item.show && !item.checked ? 'hover' : '']"
              />
              <img
                src="../../../assets/imgs/order/triangle.png"
                class="icon-triangle"
                v-show="item.checked"
              />
              <span :class="['desc', item.checked ? 'checked' : '']">{{
                item.evaluation
              }}</span>
            </div>
          </div>

          <div
            class="tags-comment-box"
            v-for="(item, eIndex) in evaluationList"
            :key="item.level"
            v-show="item.checked"
          >
            <div class="tag-list">
              <div class="evaluation-line-title align-first-line">印象</div>
              <div class="tag-box">
                <div
                  :class="['tag', tag.checked ? 'tag-checked' : '']"
                  v-for="(tag, tagIndex) in item.tagList"
                  :key="tag.id"
                  @click="handlerTag(eIndex, tagIndex)"
                >
                  <div class="text">{{ tag.content }}</div>
                </div>
              </div>
            </div>

            <div class="comment-list">
              <div class="evaluation-line-title align-first-line">点评</div>
              <div class="evaluation-line-right">
                <div
                  :class="['comment-box', commentFocus ? 'focus' : '']"
                  v-show="item.checked"
                >
                  <el-input
                    type="textarea"
                    :rows="4"
                    :maxlength="500"
                    @focus="commentFocus = true"
                    @blur="commentFocus = false"
                    :placeholder="item.defaultComment"
                    v-model="item.comment"
                  >
                  </el-input>
                  <div class="word-tips">
                    <span class="filled-word">{{ item.comment.length }}</span
                    >/500
                  </div>
                </div>
                <div class="picture-evaluation-list">
                  <upload-image
                    :image-list="commentImageList"
                    :max-length="6"
                    @add="addUploadImage"
                    @delete="deleteUploadImage"
                  ></upload-image>
                  <div class="picture-evaluation-tips">
                    请上传jpg，jpeg，png格式大小不超过5M的图片
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="anonymous">
            <el-checkbox v-model="isAnonymous">匿名提交</el-checkbox>
          </div>

          <div class="footer-box">
            <el-button
              :loading="submitLoading"
              class="submit-btn"
              @click="submiteEvaluation"
              >提交</el-button
            >
          </div>
        </div>
        <!-- 查看评价 -->
        <div class="detail-box" v-else>
          <div class="reply-people">
            <div class="left-box">
              <div
                v-if="order_review.wxinfo && order_review.wxinfo.avatarurl"
                :style="{
                  backgroundImage: 'url(' + order_review.wxinfo.avatarurl + ')',
                }"
                class="avatar"
              ></div>
              <div class="name">{{ order_review.peer_account_name }}</div>
            </div>
            <div class="right-box">{{ order_review.create_time }}</div>
          </div>

          <div class="evaluation-box paddingLeftRight20">
            <div class="evaluation-line-title">评价</div>
            <div
              class="evaluation"
              v-for="(item, eIndex) in evaluationList"
              :key="item.level"
              @click="handlerEvaluation(eIndex)"
            >
              <img
                :src="item.checked ? item.checkedIcon : item.commonIcon"
                class="icon-box"
              />
              <span :class="['desc', item.checked ? 'checked' : '']">{{
                item.evaluation
              }}</span>
            </div>
          </div>

          <div
            class="tags-comment-box paddingLeftRight20"
            v-for="(item, eIndex) in evaluationList"
            :key="item.level"
            v-show="item.checked"
          >
            <div class="tag-list" v-if="item.tagList.length">
              <div class="evaluation-line-title align-first-line">印象</div>
              <div class="tag-box">
                <div
                  :class="['tag', tag.checked ? 'tag-checked' : '']"
                  v-for="(tag, tagIndex) in item.tagList"
                  :key="tag.id"
                  @click="handlerTag(eIndex, tagIndex)"
                >
                  <div class="text">{{ tag.content }}</div>
                </div>
              </div>
            </div>

            <div class="comment-list">
              <div
                :class="[
                  'evaluation-line-title',
                  'align-first-line',
                  isdetail ? 'line-middle' : '',
                ]"
              >
                点评
              </div>
              <div class="reply-box" v-show="item.checked">
                <div class="client-reply" v-if="order_review.content">
                  {{ order_review.content }}
                </div>
                <div class="client-reply" v-if="!order_review.content">
                  没有填写评价内容
                </div>
                <div class="staff-reply" v-if="order_review.reply_content">
                  <div class="words-box">
                    回复：{{ order_review.reply_content }}
                  </div>
                  <div class="time-box">{{ order_review.reply_time }}</div>
                </div>

                <div class="picture-evaluation-list">
                  <div
                    class="picture-evaluation-li-pic"
                    v-for="(pic, index) in order_review.order_review_pic_set"
                    :key="index"
                  >
                    <img :src="pic" v-viewer />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from '@/libs/http';
import { mapState } from 'vuex';
import UploadImage from '@/components/upload/upload-image.vue';

export default {
  data() {
    return {
      maxLength: 6,
      evaluationList: [
        {
          level: 1,
          evaluation: '好评',
          checked: true,
          show: false,
          checkedIcon:
            'https://o.666visa.cn/static/ssqpeer/order/rateA_checked.png',
          commonIcon: 'https://o.666visa.cn/static/ssqpeer/order/rateA.png',
          tagList: [],
          comment: '',
          defaultComment: '服务非常满意，表扬一下吧',
        },
        {
          level: 2,
          evaluation: '中评',
          checked: false,
          show: false,
          checkedIcon:
            'https://o.666visa.cn/static/ssqpeer/order/rateB_checked.png',
          commonIcon: 'https://o.666visa.cn/static/ssqpeer/order/rateB.png',
          tagList: [],
          comment: '',
          defaultComment: '说出您的不满，帮助我们提升服务质量',
        },
        {
          level: 3,
          evaluation: '差评',
          checked: false,
          show: false,
          checkedIcon:
            'https://o.666visa.cn/static/ssqpeer/order/rateC_checked.png',
          commonIcon: 'https://o.666visa.cn/static/ssqpeer/order/rateC.png',
          tagList: [],
          comment: '',
          defaultComment: '说出您的不满，帮助我们提升服务质量',
        },
      ],
      isdetail: false,
      submitLoading: false,
      title: '',
      nationalImg: '',
      order_review: {},
      commentFocus: false,
      fileSet: [],
      commentImageList: [],
      isAnonymous: false,
    };
  },
  components: {
    UploadImage,
  },
  computed: {
    ...mapState('config', ['order_review_config']),
  },
  methods: {
    // 点击评价
    handlerEvaluation(eIndex) {
      if (this.isdetail) return;
      this.evaluationList.forEach((evaluation, index) => {
        if (index === eIndex) {
          this.evaluationList[index].checked = true;
        } else {
          this.evaluationList[index].checked = false;
        }
      });
    },

    // 点击标签
    handlerTag(eIndex, tagIndex) {
      if (this.isdetail) return;
      this.evaluationList[eIndex].tagList[tagIndex].checked =
        !this.evaluationList[eIndex].tagList[tagIndex].checked;
    },

    // 初始化数据
    initData() {
      this.getEvaluationDetail();
    },

    // 获取评价详情
    getEvaluationDetail() {
      Http.post('/order_query', { user_order_id: +this.$route.params.oid })
        .then((res) => {
          const { order_review } = res;
          if (order_review && order_review.order_review_id) {
            this.isdetail = true;
          }

          this.nationalImg = res.national_flag_img;
          this.title = `${order_review.title}`;
          this.order_review = order_review;
          this.isAnonymous = order_review.is_anonymous;
          if (!this.isdetail) {
            setTimeout(() => {
              this.setDefaultTags();
            }, 100);
          } else {
            this.evaluationList = this.evaluationList
              .filter(item => item.level === order_review.level)
              .map((item) => {
                item.checked = true;
                item.tagList = order_review.order_review_label.map(tag => ({
                  checked: true,
                  ...tag,
                }));
                return item;
              });
          }
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },

    // 设置默认的标签数组
    setDefaultTags() {
      Object.keys(this.order_review_config).forEach((key, index) => {
        const config = this.order_review_config[key];
        this.evaluationList[index].tagList = config.map(item => ({
          checked: false,
          ...item,
        }));
      });
    },

    // 上传的评价图片
    uploadSuccess(files) {
      this.commentImageList = files;
    },

    // 提交
    submiteEvaluation() {
      const currentEvaluationInfo = this.evaluationList
        .filter(item => item.checked)
        .pop();
      const label_id_set = currentEvaluationInfo.tagList
        .filter(tag => tag.checked)
        .map(tag => tag.id);
      const params = {
        user_order_id: +this.$route.params.oid,
        level: currentEvaluationInfo.level,
        label_id_set,
        content: currentEvaluationInfo.comment,
        order_review_pic_set: this.commentImageList.map(item => item.url),
        is_anonymous: this.isAnonymous ? 1 : 0,
      };
      this.submitLoading = true;
      Http.post('/order_review_add', params)
        .then(() => {
          this.submitLoading = false;
          this.$message.success('评价成功，感谢您！');
          this.$router.go(-1);
        })
        .catch(() => {
          this.submitLoading = false;
          this.initData();
        });
    },
    addUploadImage(payload) {
      this.commentImageList.push(payload);
    },
    deleteUploadImage(index) {
      this.commentImageList.splice(index, 1);
    },
  },
  created() {
    this.initData();
  },
};
</script>

<style lang="less">
.order-evaluation {
  .el-textarea {
    height: 110px;
    .el-textarea__inner {
      border: none;
      height: 110px;
      background-color: #fbfbfb;
      padding-left: 10px;
    }
  }
}
</style>

<style lang="less" scoped>
.order-evaluation {
  .content-box {
    width: 1000px;
    margin: 0 auto;
    border-radius: 4px;
    .main-box {
      background-color: #ffffff;
      margin-bottom: 60px;
      padding-bottom: 40px;
      .title {
        height: 78px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: rgba(94, 155, 225, 0.1);
        color: #aaaaaa;
        .text {
          font-size: 16px;
        }
        .desc {
          font-size: 12px;
          margin-top: 10px;
        }
      }
      .order-info {
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        .text-box {
          font-size: 22px;
          color: #333333;
        }
        .country-icon {
          width: 26px;
          height: 26px;
          background-size: cover;
          background-position: center;
          margin-right: 10px;
          border-radius: 50%;
          border: 1px solid #f0f0f0;
        }
      }
      .submit-box {
        margin: 0 160px;
      }
      .evaluation-box {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #f0f0f0;
        .evaluation {
          display: flex;
          align-items: center;
          margin-right: 70px;
          position: relative;
          cursor: pointer;
          .icon-box {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            &.hover {
              opacity: 0.5;
            }
          }
          .icon-triangle {
            position: absolute;
            bottom: -21px;
            left: 13px;
          }
          .desc {
            font-size: 16px;
            color: #aaaaaa;
            &.checked {
              color: #333333;
            }
          }
        }
      }
      .tags-comment-box {
        padding-top: 30px;
        .tag-list {
          display: flex;
          align-items: center;
          padding-bottom: 15px;
          .tag-box {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            min-height: 49px;
            .tag {
              width: 140px;
              height: 34px;
              border-radius: 17px;
              border: solid 1px #e3e3e3;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              color: #6f6f6f;
              margin: 0 15px 15px 0;
              cursor: pointer;
              transition: all 0.4s;
              &:hover {
                color: #5e9be1;
                border: 1px solid #5e9be1;
              }
              &.tag-checked {
                color: #ffffff;
                border: none;
                background-color: #5e9be1;
              }
              .text {
                max-width: 112px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }

        .comment-list {
          display: flex;
          align-items: center;
          .comment-box {
            flex-grow: 1;
            background-color: #fbfbfb;
            border-radius: 4px;
            border: solid 1px #e3e3e3;
            transition: all 0.4s;
            &.focus {
              border: solid 1px #3fa2f5;
            }
            .word-tips {
              font-size: 12px;
              color: #aaaaaa;
              padding: 10px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              .filled-word {
                color: #ff5a60;
              }
            }
          }
        }
      }
      .picture-evaluation-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-top: 16px;
        .picture-evaluation-li-pic {
          width: 88px;
          height: 88px;
          border-radius: 6px;
          overflow: hidden;
          margin-right: 20px;
          margin-bottom: 20px;
          > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            &:hover {
              cursor: pointer;
            }
          }
        }
        .picture-evaluation-tips {
          font-size: 12px;
          color: #91999f;
          padding: 0 20px 22px 0;
        }
      }
      .anonymous {
        display: flex;
        height: 14px;
        font-size: 14px;
        align-items: center;
        color: #5f666e;
        margin-left: 50px;
      }
      .footer-box {
        display: flex;
        justify-content: center;
        align-items: center;
        .submit-btn {
          width: 280px;
          height: 40px;
          background-color: #5e9be1;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #ffffff;
          margin: 30px 0 0;
          border: none;
          cursor: pointer;
        }
      }
      .evaluation-line-title {
        font-size: 16px;
        color: #333333;
        margin-right: 20px;
        font-weight: 600;
        white-space: nowrap;
        &.align-first-line {
          align-self: flex-start;
          transform: translateY(9px);
        }
        &.line-middle {
          transform: translateY(3px);
        }
      }
      .evaluation-line-right {
        display: flex;
        flex-direction: column;
        flex: 1;
      }

      .detail-box {
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #f0f0f0;
        margin: 0 140px;
        .reply-people {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 40px;
          border-bottom: 1px dashed #f0f0f0;
          margin-bottom: 20px;
          padding: 0 20px;
          .left-box {
            display: flex;
            align-items: center;
            .avatar {
              width: 24px;
              height: 24px;
              background-size: cover;
              background-position: center;
              margin-right: 10px;
              border-radius: 50%;
              border: 1px solid #f0f0f0;
            }
            .name {
              font-size: 14px;
              color: #333333;
            }
          }
          .right-box {
            font-size: 12px;
            color: #aaaaaa;
          }
        }
        .evaluation-box {
          border-bottom: none;
        }
        .tags-comment-box {
          padding-top: 0;
        }
        .comment-list {
          padding-bottom: 25px;
          .reply-box {
            font-size: 14px;
            color: #333333;
            line-height: 24px;
            word-break: break-all;
            .client-reply {
            }
            .staff-reply {
              background-color: #f7f8fa;
              padding: 10px 20px 8px 15px;
              position: relative;
              margin-top: 6px;
              min-width: 600px;
              border-radius: 4px;
              .time-box {
                margin-top: 2px;
                font-size: 12px;
                color: #aaaaaa;
                text-align: right;
              }
              .staff-name {
                color: #5e9be1;
                margin-right: 5px;
                display: inline-block;
                font-weight: 600;
              }
              &::before {
                content: "";
                position: absolute;
                top: -14px;
                left: 17px;
                border-top: 7px solid transparent;
                border-bottom: 7px solid #f7f8fa;
                border-left: 7px solid transparent;
                border-right: 7px solid transparent;
              }
            }
          }
        }
      }
      .paddingLeftRight20 {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/orders/order-evaluation/orderEvaluation.vue